import { Link } from "react-router-dom";

export default function SiteFooter() {
  return (
    <footer className="bg-primary-900 text-background-100">
      <div className="w-full px-4 md:px-8 lg:px-12 py-12 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-500 text-lg font-black text-primary-950 font-heading">
                奸
              </span>
              <div className="flex flex-col leading-none">
                <span className="font-heading text-lg font-black tracking-wide text-background-50">
                  奸情<span className="text-accent-400">·</span>影视
                </span>
                <span className="mt-1 font-label text-[10px] uppercase tracking-[0.28em] text-background-300">
                  Film &amp; Story
                </span>
              </div>
            </div>
            <p className="mt-5 max-w-md text-sm leading-7 text-background-300">
              一个专注影视剧推荐与剧情解析的内容站。我们用编辑视角梳理剧集看点、角色关系与幕后细节，
              让好看的剧被更多人看见，也让看过的剧值得再看一遍。
            </p>
            <div className="mt-6 flex flex-wrap gap-2">
              {["剧情解析", "影视推荐", "幕后揭秘", "专题片单"].map((item) => (
                <span
                  key={item}
                  className="rounded-full border border-background-50/20 px-3 py-1 text-xs text-background-200"
                >
                  {item}
                </span>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold tracking-wide text-background-50">
              <span className="block border-b border-background-50/15 pb-2">浏览栏目</span>
            </h4>
            <ul className="mt-4 space-y-2.5 text-sm text-background-300">
              {[
                { label: "首页", to: "/" },
                { label: "影视剧分类", to: "/category" },
                { label: "资讯栏目", to: "/news" },
                { label: "专题策划", to: "/special" },
                { label: "全站搜索", to: "/search" },
              ].map((item) => (
                <li key={item.to}>
                  <Link to={item.to} className="transition-colors hover:text-accent-300">
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold tracking-wide text-background-50">
              <span className="block border-b border-background-50/15 pb-2">联系我们</span>
            </h4>
            <ul className="mt-4 space-y-3 text-sm text-background-300">
              <li className="flex items-start gap-2">
                <i className="ri-mail-line mt-0.5 text-base text-accent-400" aria-hidden="true" />
                <span>editor@jianqing-film.example.com</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-line mt-0.5 text-base text-accent-400" aria-hidden="true" />
                <span>内容编辑部 · 线上运营</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-time-line mt-0.5 text-base text-accent-400" aria-hidden="true" />
                <span>每周一、三、五更新</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-background-50/15 pt-6 text-xs text-background-400 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2025 奸情影视内容站 · 保留所有权利</p>
          <p className="text-background-400">
            站内剧集、人物与资讯均为虚构演示内容，仅用于展示页面结构与阅读体验。
          </p>
        </div>
      </div>
    </footer>
  );
}